import InterviewSuggestForm, {
  initialState,
  State,
} from 'components/Interview/SuggestForm';
import { FC, useState } from 'react';

const SuggestInterview: FC = () => {
  const [state, setState] = useState<State>(initialState);
  return (
    <InterviewSuggestForm
      {...{ state, setState }}
      backTo="/mentor/mentorship/management/interviews"
    />
  );
};

export default SuggestInterview;
